import api from '@/api/base'

export default {
  login(pin) {
    return api().patch(`/crew-dispatch/${pin}`);
  },
}
